import { Navigate } from 'react-router-dom';

// /partner/mypage/info 는 본페이지 /partner/mypage 의 정보수정 섹션으로 통합됨.
const CompanyInfo = () => <Navigate to="/partner/mypage" replace />;

export default CompanyInfo;
